module.exports = __webpack_public_path__ + "img/sos.b02b74dc.svg";